// Imports
import React from "react"
import { ScrollContainer } from "react-indiana-drag-scroll"
import { ServiceCard } from "@molecules"
import {
  heroContainerMediaQueries,
  useWindowWidth,
  generateString,
} from "@utils"

export const ServicesCard = ({
  displayData,
  displayDataAll,
}) => {
  const windowWidth = useWindowWidth()

  return (
    <div className="services-cards">
      <ScrollContainer>
        <div className="services-cards-wrapper">
          <React.Fragment>
            <ServiceCard mock first />

            {windowWidth >= heroContainerMediaQueries.xl
              ? displayData.map((service, index) => {
                  return (
                    <React.Fragment key={generateString(30)}>
                      <ServiceCard
                        title={service.title}
                        desc={service.shortDescription.shortDescription}
                        image={service.image.gatsbyImageData}
                        small={service.small}
                        index={index}
                      />
                    </React.Fragment>
                  )
                })
              : displayDataAll.map((service, index) => {
                  return (
                    <React.Fragment key={generateString(30)}>
                      <ServiceCard
                        title={service.title}
                        desc={service.shortDescription.shortDescription}
                        image={service.image.gatsbyImageData}
                        small={service.small}
                        imageURL={service.image.url}
                        index={index}
                      />
                    </React.Fragment>
                  )
                })}
            <ServiceCard mock />
          </React.Fragment>
        </div>
      </ScrollContainer>
    </div>
  )
}
